import { isNil } from '@pct-ts/typeguard';

export function extractTextFromHtml(htmlString?: string | null): string {
  if (isNil(htmlString)) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || doc.body.innerText || '';
}
